module.exports = __webpack_public_path__ + "media/images/logo-full-red-81eb09576abb7c0f9a3fee04717331bd.png";